import PropTypes from 'prop-types'
import React, { createContext, useContext, useEffect, useState } from 'react'

const defaultValue = {}
const BreakpointContext = createContext(defaultValue)

const queries = {
  xs: '(min-width: 360px)',
  sm: '(min-width: 440px)',
  md: '(min-width: 640px)',
  fb: '(min-width: 768px)',
  lg: '(min-width: 1024px)',
  xl: '(min-width: 1280px)',
  mdl: '(min-width: 1366px)',
  xxl: '(min-width: 1536px)',
  fhd: '(min-width: 1920px)',
  qhd: '(min-width: 2560px)',
  uhd: '(min-width: 3840px)',
  //or: '(orientation: portrait)', // we can check orientation also
}

const BreakpointProvider = ({ children }) => {
  const [queryMatch, setQueryMatch] = useState({})

  useEffect(() => {
    if (localStorage.getItem && localStorage.getItem('log_breakpoint_provider')) {
      const x = {}
      for (const key of Object.keys(queryMatch)) {
        x[key] = queryMatch[key]
      }
      console.info(x)

      const active = Object.entries(x).reduce((acc, [key, value]) => {
        if (value) {
          acc.push(key)
        }
        return acc
      }, [])

      console.info(active.join(', '))
    }
  }, [queryMatch])

  useEffect(() => {
    const mediaQueryLists = {}
    const keys = Object.keys(queries)
    let isAttached = false

    const handleQueryListener = () => {
      const updatedMatches = keys.reduce((acc, media) => {
        acc[media] = !!(mediaQueryLists[media] && mediaQueryLists[media].matches)
        return acc
      }, {})
      setQueryMatch(updatedMatches)
    }

    if (window && global.matchMedia) {
      const matches = {}
      keys.forEach((media) => {
        if (typeof queries[media] === 'string') {
          mediaQueryLists[media] = global.matchMedia(queries[media])
          matches[media] = mediaQueryLists[media].matches
        } else {
          matches[media] = false
        }
      })
      setQueryMatch(matches)
      isAttached = true
      keys.forEach((media) => {
        try {
          mediaQueryLists[media].addEventListener('change', handleQueryListener)
        } catch (error) {
          mediaQueryLists[media].addListener(handleQueryListener)
        }
      })
    }

    return () => {
      if (isAttached) {
        keys.forEach((media) => {
          if (typeof queries[media] === 'string') {
            try {
              mediaQueryLists[media].removeEventListener('change', handleQueryListener)
            } catch (error) {
              mediaQueryLists[media].removeListener(handleQueryListener)
            }
          }
        })
      }
    }
  }, [queries])

  return <BreakpointContext.Provider value={queryMatch}>{children}</BreakpointContext.Provider>
}
BreakpointProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
  queries: PropTypes.object,
}

function useBreakpoint() {
  const context = useContext(BreakpointContext)
  if (context === defaultValue) {
    throw new Error('useBreakpoint must be used within BreakpointProvider')
  }
  return context
}

export { useBreakpoint, BreakpointProvider }
